// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"49968310","919":"64c41bb8"}[chunkId] + ".js";
};